import { getFolderResourceItems, resourceFolderFileUrl } from './folderResources';

/**
 * Files in public/resources/employers/ - keep in sync when adding/removing assets.
 * Uses generic helpers in folderResources.js (same pattern as parent/community/educator lists).
 */
const EMPLOYERS_SEGMENT = 'employers';

/** URL for one file in public/resources/employers/ */
export function employerAssetFile(filename) {
  return resourceFolderFileUrl(EMPLOYERS_SEGMENT, filename);
}

/** @type {Array<{ id: string, title: string, description: string, filename: string, icon?: string }>} */
export const EMPLOYER_RESOURCE_FILES = [
  {
    id: 'achev-aewg-toolkit',
    title: 'AEWG toolkit for employers - Paving the Way',
    description:
      'Toolkit from Achev / AEWG for employers on inclusive pathways and supporting women in the workplace (March 2024).',
    filename: 'Achev-AEWG-Toolkit-for-Employers-Paving-the-Way-by-SEASONOVA-March-2024.pdf',
    icon: '📄',
  },
  {
    id: 'championing-women-toolkit',
    title: 'Championing women in business - toolkit for employers',
    description: 'Employer-focused toolkit on championing women in business settings.',
    filename: 'Championing-Women-in-Business-Toolkit-for-Employers.pdf',
    icon: '📄',
  },
  {
    id: 'eco-canada-dei',
    title: 'ECO Canada DEI toolkit for employers',
    description: 'Diversity, equity, and inclusion toolkit for employers from ECO Canada.',
    filename: 'ECO-Canada-DEI-Toolkit-for-Employers.pdf',
    icon: '📄',
  },
  {
    id: 'ehrc-returnship',
    title: 'EHRC returnship toolkit',
    description: 'Electricity Human Resources Canada - guidance on returnship programs and pathways back to work.',
    filename: 'EHRC_ReturnshipToolkit_v4.pdf',
    icon: '📄',
  },
  {
    id: 'workplace-equity',
    title: 'How to improve workplace equity',
    description: 'Practical framing and actions to strengthen equity in the workplace.',
    filename: 'How to Improve Workplace Equity.pdf',
    icon: '📄',
  },
  {
    id: 'hiring-promotion-infosheet',
    title: 'Hiring & promotion infosheet',
    description: 'Infosheet on hiring and promotion practice (July 2025).',
    filename: 'Infosheet_Hiring-Promotion-jul2025.pdf',
    icon: '📄',
  },
  {
    id: 'interactive-career-quizzes',
    title: 'Interactive career quizzes (free and practical)',
    description: 'Word document with career quiz ideas you can use in coaching or HR conversations.',
    filename: 'Interactive Career Quizzes (Free and Practical).docx',
    icon: '📝',
  },
  {
    id: 'mason-goulden',
    title: 'Mason-Goulden resource',
    description: 'PDF resource for employers (Mason-Goulden).',
    filename: 'Mason-Goulden.pdf',
    icon: '📄',
  },
  {
    id: 'returning-after-leave',
    title: 'Returning to work after an extended leave',
    description: 'Guidance on supporting employees returning after extended leave.',
    filename: 'returning_to_work_after_an_extended_leave.pdf',
    icon: '📄',
  },
];

/** Items shaped for Resources page (employers section). */
export function getEmployerResourceItems() {
  return getFolderResourceItems(EMPLOYERS_SEGMENT, EMPLOYER_RESOURCE_FILES);
}
